// Headings
export const HEADING_REORDER = "HEADING_REORDER";
export const HEADING_REORDER_SUCCESS = "HEADING_REORDER_SUCCESS";
export const HEADING_REORDER_FAILURE = "HEADING_REORDER_FAILURE";

export const HEADING_COPY = "HEADING_COPY";
export const HEADING_COPY_SUCCESS = "HEADING_COPY_SUCCESS";
export const HEADING_COPY_FAILURE = "HEADING_COPY_FAILURE";

export const HEADING_MOVE = "HEADING_MOVE";
export const HEADING_MOVE_SUCCESS = "HEADING_MOVE_SUCCESS";
export const HEADING_MOVE_FAILURE = "HEADING_MOVE_FAILURE";

// Library
export const FETCH_ASSET_VIEWS = "FETCH_ASSET_VIEWS";
export const FETCH_ASSET_VIEWS_SUCCESS = "FETCH_ASSET_VIEWS_SUCCESS";
export const FETCH_ASSET_VIEWS_FAILURE = "FETCH_ASSET_VIEWS_FAILURE";

export const FETCH_ASSET_VIEW = "FETCH_ASSET_VIEW";
export const FETCH_ASSET_VIEW_SUCCESS = "FETCH_ASSET_VIEW_SUCCESS";
export const FETCH_ASSET_VIEW_FAILURE = "FETCH_ASSET_VIEW_FAILURE";

export const CREATE_ASSET_VIEW = "CREATE_ASSET_VIEW";
export const CREATE_ASSET_VIEW_SUCCESS = "CREATE_ASSET_VIEW_SUCCESS";
export const CREATE_ASSET_VIEW_FAILURE = "CREATE_ASSET_VIEW_FAILURE";

export const DELETE_ASSET_VIEW = "DELETE_ASSET_VIEW";
export const DELETE_ASSET_VIEW_SUCCESS = "DELETE_ASSET_VIEW_SUCCESS";
export const DELETE_ASSET_VIEW_FAILURE = "DELETE_ASSET_VIEW_FAILURE";

export const UPDATE_ASSET_VIEW = "UPDATE_ASSET_VIEW";
export const UPDATE_ASSET_VIEW_SUCCESS = "UPDATE_ASSET_VIEW_SUCCESS";
export const UPDATE_ASSET_VIEW_FAILURE = "UPDATE_ASSET_VIEW_FAILURE";

export const FETCH_LIBRARY_ASSETS = "FETCH_LIBRARY_ASSETS";
export const FETCH_LIBRARY_ASSETS_SUCCESS = "FETCH_LIBRARY_ASSETS_SUCCESS";
export const FETCH_LIBRARY_ASSETS_FAILURE = "FETCH_LIBRARY_ASSETS_FAILURE";

export const FETCH_ASSET = "FETCH_ASSET";
export const FETCH_ASSET_SUCCESS = "FETCH_ASSET_SUCCESS";
export const FETCH_ASSET_FAILURE = "FETCH_ASSET_FAILURE";

export const DELETE_ASSETS = "DELETE_ASSETS";
export const DELETE_ASSETS_SUCCESS = "DELETE_ASSETS_SUCCESS";
export const DELETE_ASSETS_FAILURE = "DELETE_ASSETS_FAILURE";

export const DELETE_ASSET_ITEMS = "DELETE_ASSET_ITEMS";
export const DELETE_ASSET_ITEMS_SUCCESS = "DELETE_ASSET_ITEMS_SUCCESS";
export const DELETE_ASSET_ITEMS_FAILURE = "DELETE_ASSET_ITEMS_FAILURE";

export const CREATE_ITEMS_FROM_ASSETS = "CREATE_ITEMS_FROM_ASSETS";
export const CREATE_ITEMS_FROM_ASSETS_SUCCESS = "CREATE_ITEMS_FROM_ASSETS_SUCCESS ";
export const CREATE_ITEMS_FROM_ASSETS_FAILURE = "CREATE_ITEMS_FROM_ASSETS_FAILURE";

export const FETCH_TAG_SUGGESTIONS = "FETCH_TAG_SUGGESTIONS";
export const FETCH_TAG_SUGGESTIONS_SUCCESS = "FETCH_TAG_SUGGESTIONS_SUCCESS";
export const FETCH_TAG_SUGGESTIONS_FAILURE = "FETCH_TAG_SUGGESTIONS_FAILURE";

export const DELETE_TAGS = "DELETE_TAGS";
export const DELETE_TAGS_SUCCESS = "DELETE_TAGS_SUCCESS";
export const DELETE_TAGS_FAILURE = "DELETE_TAGS_FAILURE";

export const UPDATE_TAGS = "UPDATE_TAGS";
export const UPDATE_TAGS_SUCCESS = "UPDATE_TAGS_SUCCESS";
export const UPDATE_TAGS_FAILURE = "UPDATE_TAGS_FAILURE";

export const REORDER_CUSTOM_FIELDS = "REORDER_CUSTOM_FIELDS";
export const REORDER_CUSTOM_FIELDS_SUCCESS = "REORDER_CUSTOM_FIELDS_SUCCESS";
export const REORDER_CUSTOM_FIELDS_FAILURE = "REORDER_CUSTOM_FIELDS_FAILURE";

export const CREATE_CUSTOM_FIELD = "CREATE_CUSTOM_FIELD";
export const CREATE_CUSTOM_FIELD_SUCCESS = "CREATE_CUSTOM_FIELD_SUCCESS";
export const CREATE_CUSTOM_FIELD_FAILURE = "CREATE_CUSTOM_FIELD_FAILURE";

export const UPDATE_CUSTOM_FIELD = "UPDATE_CUSTOM_FIELD";
export const UPDATE_CUSTOM_FIELD_SUCCESS = "UPDATE_CUSTOM_FIELD_SUCCESS";
export const UPDATE_CUSTOM_FIELD_FAILURE = "UPDATE_CUSTOM_FIELD_FAILURE";

export const DELETE_CUSTOM_FIELD = "DELETE_CUSTOM_FIELD";
export const DELETE_CUSTOM_FIELD_SUCCESS = "DELETE_CUSTOM_FIELD_SUCCESS";
export const DELETE_CUSTOM_FIELD_FAILURE = "DELETE_CUSTOM_FIELD_FAILURE";

export const FETCH_CUSTOM_FIELDS = "FETCH_CUSTOM_FIELDS";
export const FETCH_CUSTOM_FIELDS_SUCCESS = "FETCH_CUSTOM_FIELDS_SUCCESS";
export const FETCH_CUSTOM_FIELDS_FAILURE = "FETCH_CUSTOM_FIELDS_FAILURE";

export const UPDATE_ASSETS_CUSTOM_FIELD = "UPDATE_ASSETS_CUSTOM_FIELD";
export const UPDATE_ASSETS_CUSTOM_FIELD_SUCCESS = "UPDATE_ASSETS_CUSTOM_FIELD_SUCCESS";
export const UPDATE_ASSETS_CUSTOM_FIELD_FAILURE = "UPDATE_ASSETS_CUSTOM_FIELD_FAILURE";

// Configurations for layout
export const SET_LAYOUT_CONFIG = "SET_LAYOUT_CONFIG";
export const SET_NAV_POINT = "SET_NAV_POINT";

// Authentication

export const LOGIN = "LOGIN";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";

export const REQUEST_PASSWORD_RESET = "REQUEST_PASSWORD_RESET";
export const REQUEST_PASSWORD_RESET_SUCCESS = "REQUEST_PASSWORD_RESET_SUCCESS";
export const REQUEST_PASSWORD_RESET_FAILURE = "REQUEST_PASSWORD_RESET_FAILURE";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_FAILURE = "RESET_PASSWORD_FAILURE";

export const ENTER_PASSWORD = "ENTER_PASSWORD";
export const ENTER_PASSWORD_SUCCESS = "ENTER_PASSWORD_SUCCESS";
export const ENTER_PASSWORD_FAILURE = "ENTER_PASSWORD_FAILURE";

export const FETCH_MAGIC_TOKEN = "FETCH_MAGIC_TOKEN";
export const FETCH_MAGIC_TOKEN_SUCCESS = "FETCH_MAGIC_TOKEN_SUCCESS";
export const FETCH_MAGIC_TOKEN_FAILURE = "FETCH_MAGIC_TOKEN_FAILURE";

export const REQUEST_INVITE = "REQUEST_INVITE";
export const REQUEST_INVITE_SUCCESS = "REQUEST_INVITE_SUCCESS";
export const REQUEST_INVITE_FAILURE = "REQUEST_INVITE_FAILURE";

export const LOGIN_WITH_SAML = "LOGIN_WITH_SAML";
export const LOGIN_WITH_SAML_SUCCESS = "LOGIN_WITH_SAML_SUCCESS";
export const LOGIN_WITH_SAML_FAILURE = "LOGIN_WITH_SAML_FAILURE";

export const LINK_SSO_ACCOUNT = "LINK_SSO_ACCOUNT";
export const LINK_SSO_ACCOUNT_SUCCESS = "LINK_SSO_ACCOUNT_SUCCESS";
export const LINK_SSO_ACCOUNT_FAILURE = "LINK_SSO_ACCOUNT_FAILURE";

export const LINK_GOOGLE_ACCOUNT = "LINK_GOOGLE_ACCOUNT";
export const LINK_GOOGLE_ACCOUNT_SUCCESS = "LINK_GOOGLE_ACCOUNT_SUCCESS";
export const LINK_GOOGLE_ACCOUNT_FAILURE = "LINK_GOOGLE_ACCOUNT_FAILURE";

export const ACCEPT_INVITATION = "ACCEPT_INVITATION";
export const ACCEPT_INVITATION_SUCCESS = "ACCEPT_INVITATION_SUCCESS";
export const ACCEPT_INVITATION_FAILURE = "ACCEPT_INVITATION_FAILURE";

export const REDEEM_JOIN_LINK = "REDEEM_JOIN_LINK";
export const REDEEM_JOIN_LINK_SUCCESS = "REDEEM_JOIN_LINK_SUCCESS";
export const REDEEM_JOIN_LINK_FAILURE = "REDEEM_JOIN_LINK_FAILURE";

export const FETCH_JOINABLE_SPACES = "FETCH_JOINABLE_SPACES";
export const FETCH_JOINABLE_SPACES_SUCCESS = "FETCH_JOINABLE_SPACES_SUCCESS";
export const FETCH_JOINABLE_SPACES_FAILURE = "FETCH_JOINABLE_SPACES_FAILURE";

export const SEND_EMAIL_VERIFICATION = "SEND_EMAIL_VERIFICATION";
export const SEND_EMAIL_VERIFICATION_SUCCESS = "SEND_EMAIL_VERIFICATION_SUCCESS";
export const SEND_EMAIL_VERIFICATION_FAILURE = "SEND_EMAIL_VERIFICATION_FAILURE";

export const VERIFY_EMAIL = "VERIFY_EMAIL";
export const VERIFY_EMAIL_SUCCESS = "VERIFY_EMAIL_SUCCESS";
export const VERIFY_EMAIL_FAILURE = "VERIFY_EMAIL_FAILURE";

export const JOIN_SPACE = "JOIN_SPACE";
export const JOIN_SPACE_SUCCESS = "JOIN_SPACE_SUCCESS";
export const JOIN_SPACE_FAILURE = "JOIN_SPACE_FAILURE";

export const LOGOUT = "LOGOUT";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

// User accounts

export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";
export const FETCH_USER_ABORTED = "FETCH_USER_ABORTED";

export const EDIT_USER_AVATAR = "EDIT_USER_AVATAR";
export const EDIT_USER_AVATAR_SUCCESS = "EDIT_USER_AVATAR_SUCCESS";
export const EDIT_USER_AVATAR_FAILURE = "EDIT_USER_AVATAR_FAILURE";

export const EDIT_USER_PROFILE = "EDIT_USER_PROFILE";
export const EDIT_USER_PROFILE_SUCCESS = "EDIT_USER_PROFILE_SUCCESS";
export const EDIT_USER_PROFILE_FAILURE = "EDIT_USER_PROFILE_FAILURE";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

export const VERIFY_PASSWORD = "VERIFY_PASSWORD";
export const VERIFY_PASSWORD_SUCCESS = "VERIFY_PASSWORD_SUCCESS";
export const VERIFY_PASSWORD_FAILURE = "VERIFY_PASSWORD_FAILURE";

export const CREATE_TOTP = "CREATE_TOTP";
export const CREATE_TOTP_SUCCESS = "CREATE_TOTP_SUCCESS";
export const CREATE_TOTP_FAILURE = "CREATE_TOTP_FAILURE";

export const VERIFY_TOTP = "VERIFY_TOTP";
export const VERIFY_TOTP_SUCCESS = "VERIFY_TOTP_SUCCESS";
export const VERIFY_TOTP_FAILURE = "VERIFY_TOTP_FAILURE";

export const DELETE_TOTP = "DELETE_TOTP";
export const DELETE_TOTP_SUCCESS = "DELETE_TOTP_SUCCESS";
export const DELETE_TOTP_FAILURE = "DELETE_TOTP_FAILURE";

export const FETCH_RECOVERY_CODES = "FETCH_RECOVERY_CODES";
export const FETCH_RECOVERY_CODES_SUCCESS = "FETCH_RECOVERY_CODES_SUCCESS";
export const FETCH_RECOVERY_CODES_FAILURE = "FETCH_RECOVERY_CODES_FAILURE";

export const FETCH_EMAIL_PREFS = "FETCH_EMAIL_PREFS";
export const FETCH_EMAIL_PREFS_SUCCESS = "FETCH_EMAIL_PREFS_SUCCESS";
export const FETCH_EMAIL_PREFS_FAILURE = "FETCH_EMAIL_PREFS_FAILURE";

export const SAVE_EMAIL_PREFS = "SAVE_EMAIL_PREFS";
export const SAVE_EMAIL_PREFS_SUCCESS = "SAVE_EMAIL_PREFS_SUCCESS";
export const SAVE_EMAIL_PREFS_FAILURE = "SAVE_EMAIL_PREFS_FAILURE";

export const SAVE_NOTIFICATION_SEEN = "SAVE_NOTIFICATION_SEEN";
export const SAVE_NOTIFICATION_SEEN_SUCCESS = "SAVE_NOTIFICATION_SEEN_SUCCESS";
export const SAVE_NOTIFICATION_SEEN_FAILURE = "SAVE_NOTIFICATION_SEEN_FAILURE";

// Fetch spaces

export const FETCH_SPACE = "FETCH_SPACE";
export const FETCH_SPACE_SUCCESS = "FETCH_SPACE_SUCCESS";
export const FETCH_SPACE_FAILURE = "FETCH_SPACE_FAILURE";

export const FETCH_SPACE_TRANSFER_CANDIDATES = "FETCH_SPACE_TRANSFER_CANDIDATES";
export const FETCH_SPACE_TRANSFER_CANDIDATES_SUCCESS = "FETCH_SPACE_TRANSFER_CANDIDATES_SUCCESS";
export const FETCH_SPACE_TRANSFER_CANDIDATES_FAILURE = "FETCH_SPACE_TRANSFER_CANDIDATES_FAILURE";

export const FETCH_SPACE_MEMBERS_BY_ID = "FETCH_SPACE_MEMBERS_BY_ID";
export const FETCH_SPACE_MEMBERS_BY_ID_SUCCESS = "FETCH_SPACE_MEMBERS_BY_ID_SUCCESS";
export const FETCH_SPACE_MEMBERS_BY_ID_FAILURE = "FETCH_SPACE_MEMBERS_BY_ID_FAILURE";

export const FETCH_SPACE_MEMBERS = "FETCH_SPACE_MEMBERS";
export const FETCH_SPACE_MEMBERS_SUCCESS = "FETCH_SPACE_MEMBERS_SUCCESS";
export const FETCH_SPACE_MEMBERS_FAILURE = "FETCH_SPACE_MEMBERS_FAILURE";

export const FETCH_SPACE_MEMBER_COUNTS = "FETCH_SPACE_MEMBER_COUNTS";
export const FETCH_SPACE_MEMBER_COUNTS_SUCCESS = "FETCH_SPACE_MEMBER_COUNTS_SUCCESS";
export const FETCH_SPACE_MEMBER_COUNTS_FAILURE = "FETCH_SPACE_MEMBER_COUNTS_FAILURE";

export const FETCH_SPACE_INVITATIONS = "FETCH_SPACE_INVITATIONS";
export const FETCH_SPACE_INVITATIONS_SUCCESS = "FETCH_SPACE_INVITATIONS_SUCCESS";
export const FETCH_SPACE_INVITATIONS_FAILURE = "FETCH_SPACE_INVITATIONS_FAILURE";

export const FETCH_SPACE_KITS = "FETCH_SPACE_KITS";
export const FETCH_SPACE_KITS_SUCCESS = "FETCH_SPACE_KITS_SUCCESS";
export const FETCH_SPACE_KITS_FAILURE = "FETCH_SPACE_KITS_FAILURE";

export const FETCH_SPACE_PREVIEW = "FETCH_SPACE_PREVIEW";
export const FETCH_SPACE_PREVIEW_SUCCESS = "FETCH_SPACE_PREVIEW_SUCCESS";
export const FETCH_SPACE_PREVIEW_FAILURE = "FETCH_SPACE_PREVIEW_FAILURE";

export const SELECT_SPACE_PLAN = "SELECT_SPACE_PLAN";

export const CREATE_SPACE = "CREATE_SPACE";
export const CREATE_SPACE_SUCCESS = "CREATE_SPACE_SUCCESS";
export const CREATE_SPACE_FAILURE = "CREATE_SPACE_FAILURE";

// Space Settings

export const DELETE_SPACE = "DELETE_SPACE";
export const DELETE_SPACE_SUCCESS = "DELETE_SPACE_SUCCESS";
export const DELETE_SPACE_FAILURE = "DELETE_SPACE_FAILURE";

export const EDIT_SPACE_NAME = "EDIT_SPACE_NAME";
export const EDIT_SPACE_NAME_SUCCESS = "EDIT_SPACE_NAME_SUCCESS";
export const EDIT_SPACE_NAME_FAILURE = "EDIT_SPACE_NAME_FAILURE";

export const EDIT_SPACE_THEME_IMAGES = "EDIT_SPACE_THEME_IMAGES";
export const EDIT_SPACE_THEME_IMAGES_SUCCESS = "EDIT_SPACE_THEME_IMAGES_SUCCESS";
export const EDIT_SPACE_THEME_IMAGES_FAILURE = "EDIT_SPACE_THEME_IMAGES_FAILURE";

export const EDIT_SPACE_SUBDOMAIN = "EDIT_SPACE_SUBDOMAIN";
export const EDIT_SPACE_SUBDOMAIN_SUCCESS = "EDIT_SPACE_SUBDOMAIN_SUCCESS";
export const EDIT_SPACE_SUBDOMAIN_FAILURE = "EDIT_SPACE_SUBDOMAIN_FAILURE";

export const EDIT_SPACE_AVATAR = "EDIT_SPACE_AVATAR";
export const EDIT_SPACE_AVATAR_SUCCESS = "EDIT_SPACE_AVATAR_SUCCESS";
export const EDIT_SPACE_AVATAR_FAILURE = "EDIT_SPACE_AVATAR_FAILURE";

export const EDIT_SPACE_THEME = "EDIT_SPACE_THEME";
export const EDIT_SPACE_THEME_SUCCESS = "EDIT_SPACE_THEME_SUCCESS";
export const EDIT_SPACE_THEME_FAILURE = "EDIT_SPACE_THEME_FAILURE";

export const EDIT_SPACE_PRIVACY = "EDIT_SPACE_PRIVACY";
export const EDIT_SPACE_PRIVACY_SUCCESS = "EDIT_SPACE_PRIVACY_SUCCESS";
export const EDIT_SPACE_PRIVACY_FAILURE = "EDIT_SPACE_PRIVACY_FAILURE";

export const EDIT_SPACE_DATA_PRIVACY = "EDIT_SPACE_DATA_PRIVACY";
export const EDIT_SPACE_DATA_PRIVACY_SUCCESS = "EDIT_SPACE_DATA_PRIVACY_SUCCESS";
export const EDIT_SPACE_DATA_PRIVACY_FAILURE = "EDIT_SPACE_DATA_PRIVACY_FAILURE";

// Figma Integration

export const FETCH_FIGMA_INTGERATION_STATUS = "FETCH_FIGMA_INTGERATION_STATUS";
export const FETCH_FIGMA_INTGERATION_STATUS_SUCCESS = "FETCH_FIGMA_INTGERATION_STATUS_SUCCESS";
export const FETCH_FIGMA_INTGERATION_STATUS_FAILURE = "FETCH_FIGMA_INTGERATION_STATUS_FAILURE";

export const UPDATE_FIGMA_API_KEY = "UPDATE_FIGMA_API_KEY";
export const UPDATE_FIGMA_API_KEY_SUCCESS = "UPDATE_FIGMA_API_KEY_SUCCESS";
export const UPDATE_FIGMA_API_KEY_FAILURE = "UPDATE_FIGMA_API_KEY_FAILURE";

export const ADD_FIGMA_TEAM = "ADD_FIGMA_TEAM";
export const ADD_FIGMA_TEAM_SUCCESS = "ADD_FIGMA_TEAM_SUCCESS";
export const ADD_FIGMA_TEAM_FAILURE = "ADD_FIGMA_TEAM_FAILURE";

export const REMOVE_FIGMA_TEAM = "REMOVE_FIGMA_TEAM";
export const REMOVE_FIGMA_TEAM_SUCCESS = "REMOVE_FIGMA_TEAM_SUCCESS";
export const REMOVE_FIGMA_TEAM_FAILURE = "REMOVE_FIGMA_TEAM_FAILURE";

export const DISABLE_FIGMA_INTEGRATION = "DISABLE_FIGMA_INTEGRATION";
export const DISABLE_FIGMA_INTEGRATION_SUCCESS = "DISABLE_FIGMA_INTEGRATION_SUCCESS";
export const DISABLE_FIGMA_INTEGRATION_FAILURE = "DISABLE_FIGMA_INTEGRATION_FAILURE";

export const START_FIGMA_ASSET_SYNC = "START_FIGMA_ASSET_SYNC_TEAM";
export const START_FIGMA_ASSET_SYNC_SUCCESS = "START_FIGMA_ASSET_SYNC_SUCCESS";
export const START_FIGMA_ASSET_SYNC_FAILURE = "START_FIGMA_ASSET_SYNC_FAILURE";

export const FETCH_FIGMA_FILE_CONTENTS = "FETCH_FIGMA_FILE_CONTENTS";
export const FETCH_FIGMA_FILE_CONTENTS_SUCCESS = "FETCH_FIGMA_FILE_CONTENTS_SUCCESS";
export const FETCH_FIGMA_FILE_CONTENTS_FAILURE = "FETCH_FIGMA_FILE_CONTENTS_FAILURE";

export const IDENTIFY_FIGMA_TYPE = "IDENTIFY_FIGMA_TYPE";
export const IDENTIFY_FIGMA_TYPE_SUCCESS = "IDENTIFY_FIGMA_TYPE_SUCCESS";
export const IDENTIFY_FIGMA_TYPE_FAILURE = "IDENTIFY_FIGMA_TYPE_FAILURE";

// Billing

export const FETCH_BILLING_HISTORY = "FETCH_BILLING_HISTORY";
export const FETCH_BILLING_HISTORY_SUCCESS = "FETCH_BILLING_HISTORY_SUCCESS";
export const FETCH_BILLING_HISTORY_FAILURE = "FETCH_BILLING_HISTORY_FAILURE";

export const FETCH_SPACE_PLANS = "FETCH_SPACE_PLANS";
export const FETCH_SPACE_PLANS_SUCCESS = "FETCH_SPACE_PLANS_SUCCESS";
export const FETCH_SPACE_PLANS_FAILURE = "FETCH_SPACE_PLANS_FAILURE";

export const FETCH_CHARGE_PREVIEW = "FETCH_CHARGE_PREVIEW";
export const FETCH_CHARGE_PREVIEW_SUCCESS = "FETCH_CHARGE_PREVIEW_SUCCESS";
export const FETCH_CHARGE_PREVIEW_FAILURE = "FETCH_CHARGE_PREVIEW_FAILURE";

export const CHANGE_SUBSCRIPTION = "CHANGE_SUBSCRIPTION";
export const CHANGE_SUBSCRIPTION_SUCCESS = "CHANGE_SUBSCRIPTION_SUCCESS";
export const CHANGE_SUBSCRIPTION_FAILURE = "CHANGE_SUBSCRIPTION_FAILURE";

export const EXTEND_TRIAL = "EXTEND_TRIAL";
export const EXTEND_TRIAL_SUCCESS = "EXTEND_TRIAL_SUCCESS";
export const EXTEND_TRIAL_FAILURE = "EXTEND_TRIAL_FAILURE";

export const REPLACE_CREDIT_CARD = "REPLACE_CREDIT_CARD";
export const REPLACE_CREDIT_CARD_SUCCESS = "REPLACE_CREDIT_CARD_SUCCESS";
export const REPLACE_CREDIT_CARD_FAILURE = "REPLACE_CREDIT_CARD_FAILURE";

export const REQUEST_ENTERPRISE = "REQUEST_ENTERPRISE";
export const REQUEST_ENTERPRISE_SUCCESS = "REQUEST_ENTERPRISE_SUCCESS";
export const REQUEST_ENTERPRISE_FAILURE = "REQUEST_ENTERPRISE_FAILURE";

export const CREATE_STRIPE_TOKEN = "CREATE_STRIPE_TOKEN";
export const CREATE_STRIPE_TOKEN_SUCCESS = "CREATE_STRIPE_TOKEN_SUCCESS";
export const CREATE_STRIPE_TOKEN_FAILURE = "CREATE_STRIPE_TOKEN_FAILURE";

export const CANCEL_SUBSCRIPTION = "CANCEL_SUBSCRIPTION";
export const CANCEL_SUBSCRIPTION_SUCCESS = "CANCEL_SUBSCRIPTION_SUCCESS";
export const CANCEL_SUBSCRIPTION_FAILURE = "CANCEL_SUBSCRIPTION_FAILURE";

export const TRANSFER_SPACE = "TRANSFER_SPACE";
export const TRANSFER_SPACE_SUCCESS = "TRANSFER_SPACE_SUCCESS";
export const TRANSFER_SPACE_FAILURE = "TRANSFER_SPACE_FAILURE";

export const EDIT_INVOICE = "EDIT_INVOICE";
export const EDIT_INVOICE_SUCCESS = "EDIT_INVOICE_SUCCESS";
export const EDIT_INVOICE_FAILURE = "EDIT_INVOICE_FAILURE";

export const REGENERATE_JOIN_LINK = "REGENERATE_JOIN_LINK";
export const REGENERATE_JOIN_LINK_SUCCESS = "REGENERATE_JOIN_LINK_SUCCESS";
export const REGENERATE_JOIN_LINK_FAILURE = "REGENERATE_JOIN_LINK_FAILURE";

export const DELETE_JOIN_LINK = "DELETE_JOIN_LINK";
export const DELETE_JOIN_LINK_SUCCESS = "DELETE_JOIN_LINK_SUCCESS";
export const DELETE_JOIN_LINK_FAILURE = "DELETE_JOIN_LINK_FAILURE";

export const UPDATE_SPACE_JOIN_WITH = "UPDATE_SPACE_JOIN_WITH";
export const UPDATE_SPACE_JOIN_WITH_SUCCESS = "UPDATE_SPACE_JOIN_WITH_SUCCESS";
export const UPDATE_SPACE_JOIN_WITH_FAILURE = "UPDATE_SPACE_JOIN_WITH_FAILURE";

export const ADD_SPACE_EMAIL_DOMAIN = "ADD_SPACE_EMAIL_DOMAIN";
export const ADD_SPACE_EMAIL_DOMAIN_SUCCESS = "ADD_SPACE_EMAIL_DOMAIN_SUCCESS";
export const ADD_SPACE_EMAIL_DOMAIN_FAILURE = "ADD_SPACE_EMAIL_DOMAIN_FAILURE";

export const DELETE_SPACE_EMAIL_DOMAIN = "DELETE_SPACE_EMAIL_DOMAIN";
export const DELETE_SPACE_EMAIL_DOMAIN_SUCCESS = "DELETE_SPACE_EMAIL_DOMAIN_SUCCESS";
export const DELETE_SPACE_EMAIL_DOMAIN_FAILURE = "DELETE_SPACE_EMAIL_DOMAIN_FAILURE";

export const VERIFY_SPACE_EMAIL_DOMAIN = "VERIFY_SPACE_EMAIL_DOMAIN";
export const VERIFY_SPACE_EMAIL_DOMAIN_SUCCESS = "VERIFY_SPACE_EMAIL_DOMAIN_SUCCESS";
export const VERIFY_SPACE_EMAIL_DOMAIN_FAILURE = "VERIFY_SPACE_EMAIL_DOMAIN_FAILURE";

export const UPDATE_SPACE_NOTIFICATIONS = "UPDATE_SPACE_NOTIFICATIONS";
export const UPDATE_SPACE_NOTIFICATIONS_SUCCESS = "UPDATE_SPACE_NOTIFICATIONS_SUCCESS";
export const UPDATE_SPACE_NOTIFICATIONS_FAILURE = "UPDATE_SPACE_NOTIFICATIONS_FAILURE";

export const FETCH_API_TOKENS = "FETCH_API_TOKENS";
export const FETCH_API_TOKENS_SUCCESS = "FETCH_API_TOKENS_SUCCESS";
export const FETCH_API_TOKENS_FAILURE = "FETCH_API_TOKENS_FAILURE";

export const CREATE_API_TOKEN = "CREATE_API_TOKEN";
export const CREATE_API_TOKEN_SUCCESS = "CREATE_API_TOKEN_SUCCESS";
export const CREATE_API_TOKEN_FAILURE = "CREATE_API_TOKEN_FAILURE";

export const EDIT_API_TOKEN = "EDIT_API_TOKEN";
export const EDIT_API_TOKEN_SUCCESS = "EDIT_API_TOKEN_SUCCESS";
export const EDIT_API_TOKEN_FAILURE = "EDIT_API_TOKEN_FAILURE";

export const DELETE_API_TOKEN = "DELETE_API_TOKEN";
export const DELETE_API_TOKEN_SUCCESS = "DELETE_API_TOKEN_SUCCESS";
export const DELETE_API_TOKEN_FAILURE = "DELETE_API_TOKEN_FAILURE";

// Analytics

export const FETCH_SPACE_ANALYTICS = "FETCH_SPACE_ANALYTICS";
export const FETCH_SPACE_ANALYTICS_SUCCESS = "FETCH_SPACE_ANALYTICS_SUCCESS";
export const FETCH_SPACE_ANALYTICS_FAILURE = "FETCH_SPACE_ANALYTICS_FAILURE";

// Fetch content

export const FETCH_KIT = "FETCH_KIT";
export const FETCH_KIT_SUCCESS = "FETCH_KIT_SUCCESS";
export const FETCH_KIT_FAILURE = "FETCH_KIT_FAILURE";

export const FETCH_KIT_VERSION = "FETCH_KIT_VERSION";
export const FETCH_KIT_VERSION_SUCCESS = "FETCH_KIT_VERSION_SUCCESS";
export const FETCH_KIT_VERSION_FAILURE = "FETCH_KIT_VERSION_FAILURE";

export const FETCH_KIT_VERSION_HISTORY = "FETCH_KIT_VERSION_HISTORY";
export const FETCH_KIT_VERSION_HISTORY_SUCCESS = "FETCH_KIT_VERSION_HISTORY_SUCCESS";
export const FETCH_KIT_VERSION_HISTORY_FAILURE = "FETCH_KIT_VERSION_HISTORY_FAILURE";

export const FETCH_KIT_RECENTLY_DELETED = "FETCH_KIT_RECENTLY_DELETED";
export const FETCH_KIT_RECENTLY_DELETED_SUCCESS = "FETCH_KIT_RECENTLY_DELETED_SUCCESS";
export const FETCH_KIT_RECENTLY_DELETED_FAILURE = "FETCH_KIT_RECENTLY_DELETED_FAILURE";

export const FETCH_KIT_RECOVERED_ASSETS = "FETCH_KIT_RECOVERED_ASSETS";
export const FETCH_KIT_RECOVERED_ASSETS_SUCCESS = "FETCH_KIT_RECOVERED_ASSETS_SUCCESS";
export const FETCH_KIT_RECOVERED_ASSETS_FAILURE = "FETCH_KIT_RECOVERED_ASSETS_FAILURE";

export const CLEAR_ALL_RECENTLY_DELETED = "CLEAR_ALL_RECENTLY_DELETED";
export const CLEAR_ALL_RECENTLY_DELETED_SUCCESS = "CLEAR_ALL_RECENTLY_DELETED_SUCCESS";
export const CLEAR_ALL_RECENTLY_DELETED_FAILURE = "CLEAR_ALL_RECENTLY_DELETED_FAILURE";

export const FETCH_USER_KITS = "FETCH_USER_KITS";
export const FETCH_USER_KITS_SUCCESS = "FETCH_USER_KITS_SUCCESS";
export const FETCH_USER_KITS_FAILURE = "FETCH_USER_KITS_FAILURE";

export const POLL_KIT_VERSION = "POLL_KIT_VERSION";
export const POLL_KIT_VERSION_SUCCESS = "POLL_KIT_VERSION_SUCCESS";
export const POLL_KIT_VERSION_FAILURE = "POLL_KIT_VERSION_FAILURE";

export const FETCH_KIT_OUTLINE = "FETCH_KIT_OUTLINE";
export const FETCH_KIT_OUTLINE_SUCCESS = "FETCH_KIT_OUTLINE_SUCCESS";
export const FETCH_KIT_OUTLINE_FAILURE = "FETCH_KIT_OUTLINE_FAILURE";

export const FETCH_RESOURCE_KIT = "FETCH_RESOURCE_KIT";
export const FETCH_RESOURCE_KIT_SUCCESS = "FETCH_RESOURCE_KIT_SUCCESS";
export const FETCH_RESOURCE_KIT_FAILURE = "FETCH_RESOURCE_KIT_FAILURE";

export const SEARCH_SPACE = "SEARCH_SPACE";
export const SEARCH_SPACE_SUCCESS = "SEARCH_SPACE_SUCCESS";
export const SEARCH_SPACE_FAILURE = "SEARCH_SPACE_FAILURE";
export const SEARCH_SPACE_RESET = "SEARCH_SPACE_RESET";

export const SEARCH_SPACE_SUGGESTIONS = "SEARCH_SPACE_SUGGESTIONS";
export const SEARCH_SPACE_SUGGESTIONS_SUCCESS = "SEARCH_SPACE_SUGGESTIONS_SUCCESS";
export const SEARCH_SPACE_SUGGESTIONS_FAILURE = "SEARCH_SPACE_SUGGESTIONS_FAILURE";
export const SEARCH_SPACE_SUGGESTIONS_RESET = "SEARCH_SPACE_SUGGESTIONS_RESET";

export const SEARCH_KIT = "SEARCH_KIT";
export const SEARCH_KIT_SUCCESS = "SEARCH_KIT_SUCCESS";
export const SEARCH_KIT_FAILURE = "SEARCH_KIT_FAILURE";
export const SEARCH_KIT_RESET = "SEARCH_KIT_RESET";

export const SEARCH_KIT_SUGGESTIONS = "SEARCH_KIT_SUGGESTIONS";
export const SEARCH_KIT_SUGGESTIONS_SUCCESS = "SEARCH_KIT_SUGGESTIONS_SUCCESS";
export const SEARCH_KIT_SUGGESTIONS_FAILURE = "SEARCH_KIT_SUGGESTIONS_FAILURE";
export const SEARCH_KIT_SUGGESTIONS_RESET = "SEARCH_KIT_SUGGESTIONS_RESET";

export const FETCH_KIT_MEMBERS = "FETCH_KIT_MEMBERS";
export const FETCH_KIT_MEMBERS_SUCCESS = "FETCH_KIT_MEMBERS_SUCCESS";
export const FETCH_KIT_MEMBERS_FAILURE = "FETCH_KIT_MEMBERS_FAILURE";

export const FETCH_SECTION = "FETCH_SECTION";
export const FETCH_SECTION_SUCCESS = "FETCH_SECTION_SUCCESS";
export const FETCH_SECTION_FAILURE = "FETCH_SECTION_FAILURE";

export const RESET_SECTION = "RESET_SECTION";

export const FETCH_ITEM = "FETCH_ITEM";
export const FETCH_ITEM_SUCCESS = "FETCH_ITEM_SUCCESS";
export const FETCH_ITEM_FAILURE = "FETCH_ITEM_FAILURE";

export const FETCH_MOTION_ASSET_THUMBNAILS = "FETCH_MOTION_ASSET_THUMBNAILS";
export const FETCH_MOTION_ASSET_THUMBNAILS_SUCCESS = "FETCH_MOTION_ASSET_THUMBNAILS_SUCCESS";
export const FETCH_MOTION_ASSET_THUMBNAILS_FAILURE = "FETCH_MOTION_ASSET_THUMBNAILS_FAILURE";

export const UPDATE_MOTION_ASSET_THUMBNAIL = "UPDATE_MOTION_ASSET_THUMBNAIL";
export const UPDATE_MOTION_ASSET_THUMBNAIL_SUCCESS = "UPDATE_MOTION_ASSET_THUMBNAIL_SUCCESS";
export const UPDATE_MOTION_ASSET_THUMBNAIL_FAILURE = "UPDATE_MOTION_ASSET_THUMBNAIL_FAILURE";

export const GENERATE_FILE_CUT = "GENERATE_FILE_CUT";
export const GENERATE_FILE_CUT_SUCCESS = "GENERATE_FILE_CUT_SUCCESS";
export const GENERATE_FILE_CUT_FAILURE = "GENERATE_FILE_CUT_FAILURE";

export const FETCH_ASSET_TAGS = "FETCH_ASSET_TAGS";
export const FETCH_ASSET_TAGS_SUCCESS = "FETCH_ASSET_TAGS_SUCCESS";
export const FETCH_ASSET_TAGS_FAILURE = "FETCH_ASSET_TAGS_FAILURE";

// Edit content

export const SAVE_ASSET_METADATA = "SAVE_ASSET_METADATA";
export const SAVE_ASSET_METADATA_SUCCESS = "SAVE_ASSET_METADATA_SUCCESS";
export const SAVE_ASSET_METADATA_FAILURE = "SAVE_ASSET_METADATA_FAILURE";

export const EDIT_MULTIPLE_ASSET_TAGS = "EDIT_MULTIPLE_ASSET_TAGS";
export const EDIT_MULTIPLE_ASSET_TAGS_SUCCESS = "EDIT_MULTIPLE_ASSET_TAGS_SUCCESS";
export const EDIT_MULTIPLE_ASSET_TAGS_FAILURE = "EDIT_MULTIPLE_ASSET_TAGS_FAILURE";

// Show/hide modals

export const SHOW_MODAL = "SHOW_MODAL";
export const DISMISS_MODAL = "DISMISS_MODAL";

export const NOTIFICATION_SHOW = "NOTIFICATION_SHOW";
export const NOTIFICATION_HIDE = "NOTIFICATION_HIDE";

export const UPLOADS_DISMISS = "UPLOADS_DISMISS";

// Manage members

export const INVITE_MEMBERS = "INVITE_MEMBERS";
export const INVITE_MEMBERS_SUCCESS = "INVITE_MEMBERS_SUCCESS";
export const INVITE_MEMBERS_FAILURE = "INVITE_MEMBERS_FAILURE";

export const CHANGE_SPACE_MEMBER_ROLE = "CHANGE_SPACE_MEMBER_ROLE";
export const CHANGE_SPACE_MEMBER_ROLE_SUCCESS = "CHANGE_SPACE_MEMBER_ROLE_SUCCESS";
export const CHANGE_SPACE_MEMBER_ROLE_FAILURE = "CHANGE_SPACE_MEMBER_ROLE_FAILURE";

export const BATCH_CHANGE_SPACE_MEMBER_ROLE = "BATCH_CHANGE_SPACE_MEMBER_ROLE";
export const BATCH_CHANGE_SPACE_MEMBER_ROLE_SUCCESS = "BATCH_CHANGE_SPACE_MEMBER_ROLE_SUCCESS";
export const BATCH_CHANGE_SPACE_MEMBER_ROLE_FAILURE = "BATCH_CHANGE_SPACE_MEMBER_ROLE_FAILURE";

export const DELETE_INVITATION = "DELETE_INVITATION";
export const DELETE_INVITATION_SUCCESS = "DELETE_INVITATION_SUCCESS";
export const DELETE_INVITATION_FAILURE = "DELETE_INVITATION_FAILURE";

export const DELETE_SPACE_MEMBERS = "DELETE_SPACE_MEMBERS";
export const DELETE_SPACE_MEMBERS_SUCCESS = "DELETE_SPACE_MEMBERS_SUCCESS";
export const DELETE_SPACE_MEMBERS_FAILURE = "DELETE_SPACE_MEMBERS_FAILURE";

export const LEAVE_SPACE = "LEAVE_SPACE";
export const LEAVE_SPACE_SUCCESS = "LEAVE_SPACE_SUCCESS";
export const LEAVE_SPACE_FAILURE = "LEAVE_SPACE_FAILURE";

export const INVITATION_ROLE_SELECT = "INVITATION_ROLE_SELECT";
export const INVITATION_EMAIL_ADD = "INVITATION_EMAIL_ADD";
export const INVITATION_EMAIL_REMOVE = "INVITATION_EMAIL_REMOVE";
export const INVITATION_KIT_ADD = "INVITATION_KIT_ADD";
export const INVITATION_KIT_REMOVE = "INVITATION_KIT_REMOVE";
export const INVITATION_NOTE_UPDATE = "INVITATION_NOTE_UPDATE";

// Modify kits

export const CREATE_KIT = "CREATE_KIT";
export const CREATE_KIT_SUCCESS = "CREATE_KIT_SUCCESS";
export const CREATE_KIT_FAILURE = "CREATE_KIT_FAILURE";

export const EDIT_KIT = "EDIT_KIT";
export const EDIT_KIT_SUCCESS = "EDIT_KIT_SUCCESS";
export const EDIT_KIT_FAILURE = "EDIT_KIT_FAILURE";

export const CREATE_KIT_VERSION = "CREATE_KIT_VERSION";
export const CREATE_KIT_VERSION_SUCCESS = "CREATE_KIT_VERSION_SUCCESS";
export const CREATE_KIT_VERSION_FAILURE = "CREATE_KIT_VERSION_FAILURE";

export const DUPLICATE_KIT = "DUPLICATE_KIT";
export const DUPLICATE_KIT_SUCCESS = "DUPLICATE_KIT_SUCCESS";
export const DUPLICATE_KIT_FAILURE = "DUPLICATE_KIT_FAILURE";

export const POLL_FOR_DUPLICATE_KIT = "POLL_FOR_DUPLICATE_KIT";
export const POLL_FOR_DUPLICATE_KIT_SUCCESS = "POLL_FOR_DUPLICATE_KIT_SUCCESS";
export const POLL_FOR_DUPLICATE_KIT_FAILURE = "POLL_FOR_DUPLICATE_KIT_FAILURE";

export const EDIT_KIT_VERSION = "EDIT_KIT_VERSION";
export const EDIT_KIT_VERSION_SUCCESS = "EDIT_KIT_VERSION_SUCCESS";
export const EDIT_KIT_VERSION_FAILURE = "EDIT_KIT_VERSION_FAILURE";

export const DELETE_KIT_VERSION = "DELETE_KIT_VERSION";
export const DELETE_KIT_VERSION_SUCCESS = "DELETE_KIT_VERSION_SUCCESS";
export const DELETE_KIT_VERSION_FAILURE = "DELETE_KIT_VERSION_FAILURE";

export const CHANGE_RECOMMENDED_KIT_VERSION = "CHANGE_RECOMMENDED_KIT_VERSION";
export const CHANGE_RECOMMENDED_KIT_VERSION_SUCCESS = "CHANGE_RECOMMENDED_KIT_VERSION_SUCCESS";
export const CHANGE_RECOMMENDED_KIT_VERSION_FAILURE = "CHANGE_RECOMMENDED_KIT_VERSION_FAILURE";

export const SET_KIT_USE_VERSION = "SET_KIT_USE_VERSION";
export const SET_KIT_USE_VERSION_SUCCESS = "SET_KIT_USE_VERSION_SUCCESS";
export const SET_KIT_USE_VERSION_FAILURE = "SET_KIT_USE_VERSION_FAILURE";

export const SET_KIT_FAVORITE = "SET_KIT_FAVORITE";
export const SET_KIT_FAVORITE_SUCCESS = "SET_KIT_FAVORITE_SUCCESS";
export const SET_KIT_FAVORITE_FAILURE = "SET_KIT_FAVORITE_FAILURE";

export const DELETE_KIT = "DELETE_KIT";
export const DELETE_KIT_SUCCESS = "DELETE_KIT_SUCCESS";
export const DELETE_KIT_FAILURE = "DELETE_KIT_FAILURE";

export const EDIT_KIT_PRIVACY = "EDIT_KIT_PRIVACY";
export const EDIT_KIT_PRIVACY_SUCCESS = "EDIT_KIT_PRIVACY_SUCCESS";
export const EDIT_KIT_PRIVACY_FAILURE = "EDIT_KIT_PRIVACY_FAILURE";

export const EDIT_KIT_PORTAL_ACCESS = "EDIT_KIT_PORTAL_ACCESS";
export const EDIT_KIT_PORTAL_ACCESS_SUCCESS = "EDIT_KIT_PORTAL_ACCESS_SUCCESS";
export const EDIT_KIT_PORTAL_ACCESS_FAILURE = "EDIT_KIT_PORTAL_ACCESS_FAILURE";

// Modify kit members

export const ADD_KIT_MEMBER = "ADD_KIT_MEMBER";
export const ADD_KIT_MEMBER_SUCCESS = "ADD_KIT_MEMBER_SUCCESS";
export const ADD_KIT_MEMBER_FAILURE = "ADD_KIT_MEMBER_FAILURE";

export const CHANGE_KIT_MEMBER_ROLE = "CHANGE_KIT_MEMBER_ROLE";
export const CHANGE_KIT_MEMBER_ROLE_SUCCESS = "CHANGE_KIT_MEMBER_ROLE_SUCCESS";
export const CHANGE_KIT_MEMBER_ROLE_FAILURE = "CHANGE_KIT_MEMBER_ROLE_FAILURE";

export const BATCH_CHANGE_KIT_MEMBER_ROLE = "BATCH_CHANGE_KIT_MEMBER_ROLE";
export const BATCH_CHANGE_KIT_MEMBER_ROLE_SUCCESS = "BATCH_CHANGE_KIT_MEMBER_ROLE_SUCCESS";
export const BATCH_CHANGE_KIT_MEMBER_ROLE_FAILURE = "BATCH_CHANGE_KIT_MEMBER_ROLE_FAILURE";

export const DELETE_KIT_MEMBER = "DELETE_KIT_MEMBER";
export const DELETE_KIT_MEMBER_SUCCESS = "DELETE_KIT_MEMBER_SUCCESS";
export const DELETE_KIT_MEMBER_FAILURE = "DELETE_KIT_MEMBER_FAILURE";

// Modify sections
export const CREATE_SECTION = "CREATE_SECTION";
export const CREATE_SECTION_SUCCESS = "CREATE_SECTION_SUCCESS";
export const CREATE_SECTION_FAILURE = "CREATE_SECTION_FAILURE";

export const UPDATE_SECTION = "UPDATE_SECTION";
export const UPDATE_SECTION_SUCCESS = "UPDATE_SECTION_SUCCESS";
export const UPDATE_SECTION_FAILURE = "UPDATE_SECTION_FAILURE";

export const BATCH_UPDATE_SECTIONS = "BATCH_UPDATE_SECTIONS";
export const BATCH_UPDATE_SECTIONS_SUCCESS = "BATCH_UPDATE_SECTIONS_SUCCESS";
export const BATCH_UPDATE_SECTIONS_FAILURE = "BATCH_UPDATE_SECTIONS_FAILURE";

export const DELETE_SECTION = "DELETE_SECTION";
export const DELETE_SECTION_SUCCESS = "DELETE_SECTION_SUCCESS";
export const DELETE_SECTION_FAILURE = "DELETE_SECTION_FAILURE";

export const SORT_SECTION_ITEMS = "SORT_SECTION_ITEMS";

// Download asset

export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const TRACK_COLOR_USAGE = "TRACK_COLOR_USAGE";

export const DOWNLOAD_MULTIPLE_FILES = "DOWNLOAD_MULTIPLE_FILES";
export const DOWNLOAD_MULTIPLE_FILES_SUCCESS = "DOWNLOAD_MULTIPLE_FILES_SUCCESS";
export const DOWNLOAD_MULTIPLE_FILES_FAILURE = "DOWNLOAD_MULTIPLE_FILES_FAILURE";

// Retry asset upload
export const RETRY_ASSET_FILE = "RETRY_ASSET_FILE";
export const RETRY_ASSET_FILE_SUCCESS = "RETRY_ASSET_FILE_SUCCESS";
export const RETRY_ASSET_FILE_FAILURE = "RETRY_ASSET_FILE_FAILURE";

// View actions
export const CHANGE_INSPECTOR_VIEW_MODE = "CHANGE_INSPECTOR_VIEW_MODE";
export const CHANGE_GALLERY_ASSET_VIEW_MODE = "CHANGE_GALLERY_ASSET_VIEW_MODE";

// Content management
export const DUPLICATE_ITEMS = "DUPLICATE_ITEMS";
export const DUPLICATE_ITEMS_SUCCESS = "DUPLICATE_ITEMS_SUCCESS";
export const DUPLICATE_ITEMS_FAILURE = "DUPLICATE_ITEMS_FAILURE";

export const DUPLICATE_SECTION = "DUPLICATE_SECTION";
export const DUPLICATE_SECTION_SUCCESS = "DUPLICATE_SECTION_SUCCESS";
export const DUPLICATE_SECTION_FAILURE = "DUPLICATE_SECTION_FAILURE";

export const MOVE_ITEMS = "MOVE_ITEMS";
export const MOVE_ITEMS_SUCCESS = "MOVE_ITEMS_SUCCESS";
export const MOVE_ITEMS_FAILURE = "MOVE_ITEMS_FAILURE";

export const MOVE_SECTION = "MOVE_SECTION";
export const MOVE_SECTION_SUCCESS = "MOVE_SECTION_SUCCESS";
export const MOVE_SECTION_FAILURE = "MOVE_SECTION_FAILURE";

export const SAVE_ITEM_DATA = "SAVE_ITEM_DATA";
export const SAVE_ITEM_DATA_SUCCESS = "SAVE_ITEM_DATA_SUCCESS";
export const SAVE_ITEM_DATA_FAILURE = "SAVE_ITEM_DATA_FAILURE";

export const DELETE_HEADING_WITH_ITEMS = "DELETE_HEADING_WITH_ITEMS";
export const DELETE_HEADING_WITH_ITEMS_SUCCESS = "DELETE_HEADING_WITH_ITEMS_SUCCESS";
export const DELETE_HEADING_WITH_ITEMS_FAILURE = "DELETE_HEADING_WITH_ITEMS_FAILURE";

export const CREATE_ITEM_ASSET = "CREATE_ITEM_ASSET";
export const CREATE_ITEM_ASSET_SUCCESS = "CREATE_ITEM_ASSET_SUCCESS";
export const CREATE_ITEM_ASSET_FAILURE = "CREATE_ITEM_ASSET_FAILURE";

export const REPLACE_ASSET_FILE = "REPLACE_ASSET_FILE";
export const REPLACE_ASSET_FILE_SUCCESS = "REPLACE_ASSET_FILE_SUCCESS";
export const REPLACE_ASSET_FILE_FAILURE = "REPLACE_ASSET_FILE_FAILURE";

export const FETCH_CONTENT_TYPES = "FETCH_CONTENT_TYPES";
export const FETCH_CONTENT_TYPES_SUCCESS = "FETCH_CONTENT_TYPES_SUCCESS";
export const FETCH_CONTENT_TYPES_FAILURE = "FETCH_CONTENT_TYPES_FAILURE";

export const FETCH_GOOGLE_FONTS = "FETCH_GOOGLE_FONTS";
export const FETCH_GOOGLE_FONTS_SUCCESS = "FETCH_GOOGLE_FONTS_SUCCESS";
export const FETCH_GOOGLE_FONTS_FAILURE = "FETCH_GOOGLE_FONTS_FAILURE";

// Dragging
export const SET_DRAGGING_ENTITY = "SET_DRAGGING_ENTITY";

// Inserting

export const INSERT_ASSET_ITEM = "INSERT_ASSET_ITEM";
export const INSERT_ASSET_ITEM_SUCCESS = "INSERT_ASSET_ITEM_SUCCESS";
export const INSERT_ASSET_ITEM_FAILURE = "INSERT_ASSET_ITEM_FAILURE";

export const INSERT_CHUNKED_ASSET_ITEM = "INSERT_CHUNKED_ASSET_ITEM";
export const INSERT_CHUNKED_ASSET_ITEM_SUCCESS = "INSERT_CHUNKED_ASSET_ITEM_SUCCESS";
export const INSERT_CHUNKED_ASSET_ITEM_FAILURE = "INSERT_CHUNKED_ASSET_ITEM_FAILURE";

export const INSERT_COLOR_ASSET_ITEM = "INSERT_COLOR_ASSET_ITEM";
export const INSERT_COLOR_ASSET_ITEM_SUCCESS = "INSERT_COLOR_ASSET_ITEM_SUCCESS";
export const INSERT_COLOR_ASSET_ITEM_FAILURE = "INSERT_COLOR_ASSET_ITEM_FAILURE";

export const REORDER_ITEMS = "REORDER_ITEMS";
export const REORDER_ITEMS_SUCCESS = "REORDER_ITEMS_SUCCESS";
export const REORDER_ITEMS_FAILURE = "REORDER_ITEMS_FAILURE";

export const BATCH_SAVE_ITEMS = "BATCH_SAVE_ITEMS";
export const BATCH_SAVE_ITEMS_SUCCESS = "BATCH_SAVE_ITEMS_SUCCESS";
export const BATCH_SAVE_ITEMS_FAILURE = "BATCH_SAVE_ITEMS_FAILURE";

export const BATCH_UPDATE_ITEM_STATUS = "BATCH_UPDATE_ITEM_STATUS";
export const BATCH_UPDATE_ITEM_STATUS_SUCCESS = "BATCH_UPDATE_ITEM_STATUS_SUCCESS";
export const BATCH_UPDATE_ITEM_STATUS_FAILURE = "BATCH_UPDATE_ITEM_STATUS_FAILURE";

export const LARGE_FILE_UPLOAD_START = "LARGE_FILE_UPLOAD_START";
export const LARGE_FILE_UPLOAD_START_SUCCESS = "LARGE_FILE_UPLOAD_START_SUCCESS";
export const LARGE_FILE_UPLOAD_START_FAILURE = "LARGE_FILE_UPLOAD_START_FAILURE";

export const LARGE_FILE_UPLOAD_CHUNK = "LARGE_FILE_UPLOAD_CHUNK";
export const LARGE_FILE_UPLOAD_CHUNK_SUCCESS = "LARGE_FILE_UPLOAD_CHUNK_SUCCESS";
export const LARGE_FILE_UPLOAD_CHUNK_FAILURE = "LARGE_FILE_UPLOAD_CHUNK_FAILURE";

export const LARGE_FILE_UPLOAD_FINISH = "LARGE_FILE_UPLOAD_FINISH";
export const LARGE_FILE_UPLOAD_FINISH_SUCCESS = "LARGE_FILE_UPLOAD_FINISH_SUCCESS";
export const LARGE_FILE_UPLOAD_FINISH_FAILURE = "LARGE_FILE_UPLOAD_FINISH_FAILURE";

export const ENQUEUE_UPLOAD = "ENQUEUE_UPLOAD";
export const DEQUEUE_UPLOAD = "DEQUEUE_UPLOAD";

export const BATCH_UPLOAD_STARTED = "BATCH_UPLOAD_STARTED";

export const UPLOAD_FAILURE = "UPLOAD_FAILURE";

// Search V2
export const TOGGLE_SEARCH_STEP = "TOGGLE_SEARCH_STEP";
export const ADD_QUERY_FILTER = "ADD_QUERY_FILTER";
export const REPLACE_QUERY_FILTERS = "REPLACE_QUERY_FILTERS";
export const REMOVE_QUERY_FILTER = "REMOVE_QUERY_FILTER";
export const CLEAR_QUERY_FILTERS = "CLEAR_QUERY_FILTERS";
export const CHANGE_KEYWORD_FILTER = "CHANGE_KEYWORD_FILTER";
export const CHANGE_SEARCH_SORT = "CHANGE_SEARCH_SORT";
export const CLEAR_RECENT_SEARCHES = "CLEAR_RECENT_SEARCHES";

export const FETCH_SEARCH_SUGGESTIONS = "FETCH_SEARCH_SUGGESTIONS";
export const FETCH_SEARCH_SUGGESTIONS_SUCCESS = "FETCH_SEARCH_SUGGESTIONS_SUCCESS";
export const FETCH_SEARCH_SUGGESTIONS_FAILURE = "FETCH_SEARCH_SUGGESTIONS_FAILURE";

export const FETCH_KIT_SUGGESTIONS = "FETCH_KIT_SUGGESTIONS";
export const FETCH_KIT_SUGGESTIONS_SUCCESS = "FETCH_KIT_SUGGESTIONS_SUCCESS";
export const FETCH_KIT_SUGGESTIONS_FAILURE = "FETCH_KIT_SUGGESTIONS_FAILURE";

export const FETCH_SEARCH_META = "FETCH_SEARCH_META";
export const FETCH_SEARCH_META_SUCCESS = "FETCH_SEARCH_META_SUCCESS";
export const FETCH_SEARCH_META_FAILURE = "FETCH_SEARCH_META_FAILURE";

export const SUBMIT_SEARCH_QUERY = "SUBMIT_SEARCH_QUERY";
export const SUBMIT_SEARCH_QUERY_SUCCESS = "SUBMIT_SEARCH_QUERY_SUCCESS";
export const SUBMIT_SEARCH_QUERY_FAILURE = "SUBMIT_SEARCH_QUERY_FAILURE";

// Kit collections
export const FETCH_KIT_COLLECTION = "FETCH_KIT_COLLECTION";
export const FETCH_KIT_COLLECTION_SUCCESS = "FETCH_KIT_COLLECTION_SUCCESS";
export const FETCH_KIT_COLLECTION_FAILURE = "FETCH_KIT_COLLECTION_FAILURE";

export const FETCH_KIT_COLLECTIONS = "FETCH_KIT_COLLECTIONS";
export const FETCH_KIT_COLLECTIONS_SUCCESS = "FETCH_KIT_COLLECTIONS_SUCCESS";
export const FETCH_KIT_COLLECTIONS_FAILURE = "FETCH_KIT_COLLECTIONS_FAILURE";

export const UPDATE_KIT_COLLECTION = "UPDATE_KIT_COLLECTION";
export const UPDATE_KIT_COLLECTION_SUCCESS = "UPDATE_KIT_COLLECTION_SUCCESS";
export const UPDATE_KIT_COLLECTION_FAILURE = "UPDATE_KIT_COLLECTION_FAILURE";

export const CREATE_KIT_COLLECTION = "CREATE_KIT_COLLECTION";
export const CREATE_KIT_COLLECTION_SUCCESS = "CREATE_KIT_COLLECTION_SUCCESS";
export const CREATE_KIT_COLLECTION_FAILURE = "CREATE_KIT_COLLECTION_FAILURE";

export const DELETE_KIT_COLLECTION = "DELETE_KIT_COLLECTION";
export const DELETE_KIT_COLLECTION_SUCCESS = "DELETE_KIT_COLLECTION_SUCCESS";
export const DELETE_KIT_COLLECTION_FAILURE = "DELETE_KIT_COLLECTION_FAILURE";

export const ADD_KIT_TO_COLLECTION = "ADD_KIT_TO_COLLECTION";
export const ADD_KIT_TO_COLLECTION_SUCCESS = "ADD_KIT_TO_COLLECTION_SUCCESS";
export const ADD_KIT_TO_COLLECTION_FAILURE = "ADD_KIT_TO_COLLECTION_FAILURE";

export const REMOVE_KIT_FROM_COLLECTION = "REMOVE_KIT_FROM_COLLECTION";
export const REMOVE_KIT_FROM_COLLECTION_SUCCESS = "REMOVE_KIT_FROM_COLLECTION_SUCCESS";
export const REMOVE_KIT_FROM_COLLECTION_FAILURE = "REMOVE_KIT_FROM_COLLECTION_FAILURE";

export const REORDER_COLLECTION_KITS = "REORDER_COLLECTION_KITS";
export const REORDER_COLLECTION_KITS_SUCCESS = "REORDER_COLLECTION_KITS_SUCCESS";
export const REORDER_COLLECTION_KITS_FAILURE = "REORDER_COLLECTION_KITS_FAILURE";
